import { styled } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import { useBox } from 'shared/hooks/utils';
import { unpack_validation } from 'z3k-parser/validation/types';
import { useCallback, useContext } from 'react';
import { Z3KSettings, Z3KSettingsEditor } from '../../../provider/types';
import { z3k_key_namespace } from '../../../utils/namespaces';
import { findAndChangeLinks, findLinksConfirmDelete } from 'z3k-parser/lib/find-links';
export function useListEditingCallbacks(name) {
    const { config, replace_config: onChangeConfig, validation_result, validation_warnings_result, } = useContext(Z3KSettingsEditor);
    const { addIdToBlacklist } = useContext(Z3KSettings);
    const configBox = useBox(config);
    const self = z3k_key_namespace[name];
    const onAddClick = useCallback(() => {
        const new_config = self.get.addDefault(configBox.current)[1];
        onChangeConfig(new_config);
    }, [onChangeConfig]);
    const onCopyClick = useCallback((obj) => {
        const [copy_id, new_config] = self.get.addCopy(configBox.current, 
        // @ts-ignore
        obj);
        onChangeConfig(new_config);
        return copy_id;
    }, [onChangeConfig]);
    const onChange = useCallback((new_list) => {
        onChangeConfig({
            ...configBox.current,
            [name]: new_list,
        });
    }, [onChangeConfig]);
    const onDelete = useCallback((object, new_list) => {
        addIdToBlacklist(object.id);
        onChangeConfig({
            ...findAndChangeLinks(configBox.current, object.id),
            [name]: new_list,
        });
    }, [addIdToBlacklist, onChangeConfig]);
    const onConfirmDelete = useCallback((object) => findLinksConfirmDelete(configBox.current, object.id), []);
    return {
        value: self.get.all(config),
        validation_result: unpack_validation(validation_result, name),
        validation_warnings_result: unpack_validation(validation_warnings_result, name),
        onAddClick,
        onCopyClick,
        onDelete,
        onChange,
        onConfirmDelete,
    };
}
export const openedAdaptiveMixin = (theme) => ({
    width: '100%',
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});
export const closedAdaptiveMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `250px`,
    [theme.breakpoints.up('sm')]: {
        width: `250px`,
    },
});
export const AdaptiveSizeDrawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
        ...openedAdaptiveMixin(theme),
        '& .MuiDrawer-paper': { ...openedAdaptiveMixin(theme), position: 'static' },
    }),
    ...(!open && {
        '*::-webkit-scrollbar': {
            display: 'none',
        },
        '*': {
            scrollbarWidth: 'none',
        },
        ...closedAdaptiveMixin(theme),
        '& .MuiDrawer-paper': { ...closedAdaptiveMixin(theme), position: 'static' },
    }),
}));
export const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
}));
